import React, { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import moment from 'moment'
import RepresentMoney from '../../utility/represent-money'
import {
  loadResalePricingRules,
  resolveSellerNetAmount
} from '../../utility/resale-pricing'

const HistoryTicketItem = ({
  name,
  sale_start_date,
  price,
  seller_net_amount,
  status,
  sell_date,
  event,
  original_code
}) => {
  const [sellerNetAmount, setSellerNetAmount] = useState(() =>
    resolveSellerNetAmount({ price, seller_net_amount }, null)
  )

  useEffect(() => {
    if (seller_net_amount !== null && typeof seller_net_amount !== 'undefined') {
      setSellerNetAmount(seller_net_amount)
      return undefined
    }

    let mounted = true
    const pricingAsOf = sell_date || sale_start_date || undefined

    loadResalePricingRules(pricingAsOf).then(rules => {
      if (!mounted) {
        return
      }

      setSellerNetAmount(
        resolveSellerNetAmount({ price, seller_net_amount }, rules)
      )
    })

    return () => {
      mounted = false
    }
  }, [price, seller_net_amount, sell_date, sale_start_date])

  return (
    <React.Fragment>
      <div className="history-ticket-container">
        <div className="row">
          <div className="col-sm-12 bold">{name}</div>

          <div className="col-sm-12">
            <Translate
              value="tickets.event_date"
              className="history-info-title"
            />
            <br />
            {moment(event?.end_date)?.format('D.M.YYYY')}
          </div>

          <div className="col-sm-12">
            <Translate
              value="tickets.original_code"
              className="history-info-title"
            />
            <br />
            {original_code}
          </div>

          <div className="col-sm-12">
            <Translate
              value="tickets.sale_start_date"
              className="history-info-title"
            />
            <br />
            {moment(sale_start_date)?.format('D.M.YYYY')}
          </div>

          <div className="col-sm-12">
            <Translate
              value="tickets.sell_date"
              className="history-info-title"
            />
            <br />
            {moment(sell_date)?.format('D.M.YYYY')}
          </div>

          <div className="col-sm-12">
            <Translate
              value="tickets.asking_price"
              className="history-info-title"
            />
            <br />
            <RepresentMoney sum={price} eurSuffix />
          </div>

          <div className="col-sm-12">
            <Translate
              value="tickets.own_share"
              className="history-info-title"
            />
            <br />
            <RepresentMoney sum={sellerNetAmount} eurSuffix />
          </div>
        </div>

        {status === 'SOLD' && (
          <div className="history-sold">
            <Translate value="tickets.sold" />
          </div>
        )}
      </div>
      <hr />
    </React.Fragment>
  )
}

export default HistoryTicketItem
